import React from 'react'
import {
  Box,
  Typography
} from '@mui/material';

const Currencies = () => {
  return (
    <>
          <Box className="headingBtnWrap">
            <Typography variant="h1">Currencies</Typography>
          </Box>
        </>
  )
}

export default Currencies
